module.exports = __webpack_public_path__ + "img/banner.acbda698.png";